import { useSelector } from "react-redux";
import { defaultTranslation } from "../assets/defaultTranslations";

export function useTranslation(key: string) {
    return useSelector((state: GlobalState) => state.configuration.translation[key]
      || defaultTranslation[key]
      || "MISSING_KEY_OR_VALUE");
}
